import { createReducer } from 'typesafe-actions';
import { SET_PROFILEDATA } from '../../constants/fetchConstants';
const initialState = null;
// SupplierActionType;
// CategoryActionType;
// MeasureActionType;
const profileReducer = createReducer(initialState).handleType(SET_PROFILEDATA, (state, action) => (action.payload));
export default profileReducer;
